export const GOOGLE_PLAY_LINK = "https://play.google.com/store/apps/details?id=uz.intersoft.splay";

export const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
